import type { DoohReportEventCategory } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

const DEFAULT_CATEGORY_ICON = 'fa-regular fa-calendar';

const CATEGORY_ICONS: Record<DoohReportEventCategory, string> = {
  festival: 'fa-regular fa-ticket',
  film: 'fa-regular fa-film',
  music: 'fa-regular fa-music',
  nightlife: 'fa-regular fa-champagne-glasses',
  other: DEFAULT_CATEGORY_ICON,
  sports: 'fa-regular fa-futbol',
  theatre: 'fa-regular fa-masks-theater'
};

export function getEventCategoryIcon(category: DoohReportEventCategory | null): string {
  return category ? CATEGORY_ICONS[category] : DEFAULT_CATEGORY_ICON;
}
